import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { SecurityService } from '../../Core/Security/security.service';
import { ConfigService } from '../../Core/Abstract/config.service';
import { LogService } from '../../Core/Abstract/log.service';
import { EventsEmitterService } from '../../Core/Abstract/emitter.service';

export class GridService extends SecurityService{

    protected serviceName = "";

    constructor(http:HttpClient,configService:ConfigService,eventsEmitterService: EventsEmitterService, router:Router, logger:LogService, serviceName:string) {
        super(http,configService,eventsEmitterService, router ,logger);

        this.serviceName = serviceName;
    }

    /**
     * Filter params
     * 
     * @param params { 0-n?:any }
     */
    initData(params:any): Observable<any>{
        let serviceUrl = this.baseUrl + this.serviceName+'/init?' + this.urlParamsToString(params);

        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    };
    
    /**
     * @param params { group:string, ...0-n?:any }
     */
    getGridActions(params:any): Observable<any>{
        let serviceUrl = this.baseUrl + this.serviceName+'/gridActions?' + this.urlParamsToString(params);

        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    } 

    /**
     * @param params { group:string, ...0-n?:any }
     */
    getColumnDefinition(params:any): Observable<any>{
        let serviceUrl = this.baseUrl + this.serviceName+'/columnDefinitions?' + this.urlParamsToString(params);

        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    } 

    /**
     * @param params { cookieId:Number, ...0-n?:any }
     */
    getDataCount(params:any): Observable<any>{
        let serviceUrl = this.baseUrl + this.serviceName+'/count?' + this.urlParamsToString(params);
                                      
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    /**
     * @param params { start:Number, end:number, order:string, cookieId:Number, ...0-n?:any }
     */
    getData(params:any): Observable<any>{
        let serviceUrl = this.baseUrl   + this.serviceName+'/data?' + this.urlParamsToString(params);
                                        
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    /**
     * @param params { cookieId:Number, ...0-n?:any }
     */
    getFooter(params:any): Observable<any>{
        let serviceUrl = this.baseUrl + this.serviceName+'/footer?' + this.urlParamsToString(params);
                                      
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    /**
     * @param params { cookieId:Number, ...0-n?:any }
     */
    getHeader(params:any): Observable<any>{
        let serviceUrl = this.baseUrl + this.serviceName+'/header?' + this.urlParamsToString(params);
                                      
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    /**
     * @param params { cookieId:Number, ...0-n?:any }
     */
    getTxt(params:any): Observable<any>{
        let serviceUrl = this.baseUrl + this.serviceName+'/downloadTxt?' + this.urlParamsToString(params);
                                      
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    /**
     * @param params { cookieId:Number, ...0-n?:any }
     */
     getPdf(params:any): Observable<any>{
        let serviceUrl = this.baseUrl + this.serviceName+'/downloadPdf?' + this.urlParamsToString(params);
        let customOptions = { 'headers': this.setAuthorizationHeader(null),'observe': 'response',responseType: 'blob' };
        return this.http.post<any>(serviceUrl,customOptions).pipe(map(response => {return response;}));
    }

    //Grid checkbox toggling
    /**
     * @param params { cookieId:Number }
     */
    selectAll( params:any ): Observable<any>{
        let serviceUrl = this.baseUrl   + this.serviceName + '/selectAll?'
                                        + this.urlParamsToString(params);
                                        
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    /**
     * @param params { cookieId:Number }
     */
    deselectAll( params:any ): Observable<any>{
        let serviceUrl = this.baseUrl   + this.serviceName + '/deselectAll?'
                                        + this.urlParamsToString(params);
                                        
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    /**
     * @param params { cookieId:Number, 0-n?:(Object's PK) }
     */
    select( params:any ): Observable<any>{
        let serviceUrl = this.baseUrl   + this.serviceName + '/select?'
                                        + this.urlParamsToString(params);
                                        
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    /**
     * @param params { cookieId:Number, 0-n?:(Object's PK) }
     */
    deselect( params:any ): Observable<any>{
        let serviceUrl = this.baseUrl   + this.serviceName + '/deselect?'
                                        + this.urlParamsToString(params);
                                        
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    public urlParamsToString(params:any){
        
        let urlParams = ""
        Object.keys(params).forEach( (param, index) => {
            urlParams += param + "=" + this.sanitize(params[param]) + "&"
        });

        return urlParams + 'langId=' + localStorage.getItem("langId");
    }

    //URLparams sanitization
    protected sanitize(data: any){
        return data != null ? data : '';
    }
}